import { Routes } from '@angular/router';
import { UtmBettors } from './utm-bettors';

export const UTM_BETTORS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => UtmBettors,
    data: {
      title: 'Métricas Apostadores',
      icon: 'fa-solid fa-users',
      breadcrumb: 'Métricas Apostadores'
    }
  }
];